class MattressOptionGroup extends HTMLElement {
  connectedCallback() {
    // Get the data
    this.selectedOptionValue = this.dataset.selectedOptionValue?.trim().toLowerCase();
    this.noneOption = this.dataset.noneOption === 'true';
    this.optionValues = this.dataset.optionValues
      ?.split(',')
      ?.map((option) => option.trim().toLowerCase());
    this.productOptions = this.querySelectorAll('product-option input[type="radio"]');

    // Check if the data is valid
    if (
      !this.dataset.selectedOptionValue ||
      !this.dataset.optionValues.length ||
      !this.productOptions.length
    ) {
      return;
    }

    // Save the state
    this.state = {
      single: null,
      left: null,
      right: null,
    };

    // Add event listeners to the options
    this.querySelectorAll('[data-mattress-option-value]').forEach((option) => {
      option.addEventListener('change', (e) => {
        e.preventDefault();
        const value = e.target.value;
        const type = e.target.dataset.mattressOptionValue;
        this.changeHandler(value, type);
      });
    });

    // Initialize the state
    this.initialize();
  }

  /**
   * Initialize the state.
   */
  initialize() {
    if (this.noneOption) {
      return;
    }

    if (this.selectedOptionValue.includes('/')) {
      const [left, right] = this.selectedOptionValue.split('/');
      this.state.left = this.optionValues.find((option) => left.includes(option)) || '';
      this.state.right = this.optionValues.find((option) => right.includes(option)) || '';
    } else {
      const selectedValue = this.selectedOptionValue.toLowerCase();
      this.state.single = this.optionValues.find((option) => selectedValue.includes(option)) || '';
    }
  }

  /**
   * Change handler.
   * @param {string} value - The value of the option.
   * @param {string} type - The type of the option. (single, left, right)
   */
  changeHandler(value, type) {
    this.state[type] = value;
    this.updateMainOption();
  }

  /**
   * Select the main option based on the state.
   */
  updateMainOption() {
    // Find and check the matching product option based on state
    this.productOptions.forEach((option) => {
      const optionValue = option.value.trim().toLowerCase();

      if (this.state.single) {
        // For single mattress, directly match the value
        if (optionValue.includes(this.state.single) && !optionValue.includes('/')) {
          option.checked = true;
          option.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        // For split mattress, match the left and right values
        const leftValue = optionValue.split('/')[0];
        const rightValue = optionValue.split('/')[1];
        if (!leftValue || !rightValue) {
          return;
        }
        if (leftValue.includes(this.state.left) && rightValue.includes(this.state.right)) {
          option.checked = true;
          option.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }
}

customElements.define('mattress-option-group', MattressOptionGroup);
